import reducer from "./reducers";

import * as formAction from "./actions";

export { formAction };

export default reducer;
